var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1412_24393)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.4,
    fill: "#002864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20001 26.8L23.999 8.00102L26.374 14.7239C26.374 14.7239 27.7441 18.4691 25.57 20.6432C23.3959 22.8173 21.5326 25.7037 18.5363 25.7037C15.5401 25.7037 6.44245 25.5579 5.20001 26.8Z",
    fill: "#3336BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20001 26.8L23.999 8.00102L17.2761 5.62599C17.2761 5.62599 13.5309 4.25587 11.3568 6.42998C9.1827 8.60409 6.2963 10.4674 6.2963 13.4637C6.2963 16.4599 6.44245 25.5579 5.20001 26.8Z",
    fill: "url(#paint0_linear_1412_24393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 8.00103L5.20032 26.8C6.45008 25.5598 9.99399 17.5285 11.1899 14.8777C12.3859 12.227 14.8794 10.2522 17.0649 8.08318C19.2505 5.91416 20.8878 6.66402 20.9741 6.7035L23.9993 8.00103Z",
    fill: "#959FE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1412_24393",
    x: -12.8,
    y: -12.8,
    width: 57.6,
    height: 57.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 6.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1412_24393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1412_24393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1412_24393",
    x1: 1.60445,
    y1: 23.2046,
    x2: 20.4032,
    y2: 4.40511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    stopColor: "#FEC986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2286,
    stopColor: "#FACA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3471,
    stopColor: "#F3CDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#EAD0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5869,
    stopColor: "#DED5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6164,
    stopColor: "#DBD6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8FFFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";